import emailjs from '@emailjs/browser';
import React, { useState } from 'react'
import { Button, Col, Container, Form, FormFeedback, FormText, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from 'reactstrap'

export default function QuestionUs() {
    const [firstFocus, setFirstFocus] = React.useState(false);
    const [lastFocus, setLastFocus] = React.useState(false);
    const [isValid,setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [resStatus, setResStatus] = useState();
    const [modal1, setModal1] = useState(false);
    const [modal2, setModal2] = useState(false);

    const [data,setData] = useState({
        fName:"",
        email:"",
        msg:""
    })

    const handleChange = (event) => {
        const { value, name } = event.target;
        setData({
        ...data,
        [name]: value,
        });
        var regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (name === 'email'){
            if( event.target.value.length > 0 && regEx.test(event.target.value) === false){
                setIsValid(false)
            }
            else{
                setIsValid(true)
            }
        }
    };

    const submit= () => {
        if (isValid === true){
            setSubmitting(true);
            emailjs.send('service_ov6i92r','template_m8n3z45',data,'yZ-Yc766GScRDRzWw')
            .then((res)=>{
                console.log('SUCCESS!', res.status, res.text)
                setModal2(true);
                setResStatus(res.status);
                setSubmitting(false);
            })
            .catch((err)=>{
                setModal1(true);
                setSubmitting(false);
            })
        }
        else{
            setModal1(true);
            setSubmitting(false);
        }
        
    }

    return (
        <>
        <div className='' id='feedbackform' style={{backgroundColor:'#fffffff', width:'100%', padding:'2%'}}>
            <Container>
                <Row>
                    <Col md='8' sm='10' lg='6' style={{margin:'0 auto'}}>
                        <h2 className='text-center title'>Leave us Feedback or your Questions</h2>
                        <InputGroup className={
                            "input-lg" + (firstFocus ? " input-group-focus" : "")
                        }>
                            <InputGroupAddon addonType='prepend'>
                                <InputGroupText>
                                    <i className='now-ui-icons users_circle-08'/>
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                    placeholder="First Name..."
                                    type="text"
                                    onFocus={() => setFirstFocus(true)}
                                    onBlur={() => setFirstFocus(false)}
                                    value={data.fName}
                                    name="fName"
                                    onChange={(e)=> handleChange(e)}
                            ></Input>
                        </InputGroup>
                        <InputGroup className={
                            "input-lg" + (lastFocus ? " input-group-focus" : "")
                        }>
                            <InputGroupAddon addonType='prepend'>
                                <InputGroupText>
                                    <i className='
                                    now-ui-icons ui-1_email-85'/>
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                placeholder="Email..."
                                type='email'
                                onFocus={()=>setLastFocus(true)}
                                onBlur={()=>setLastFocus(false)}
                                value={data.email}
                                name="email"
                                onChange={(e)=>handleChange(e)}
                            >
                            </Input>
                        </InputGroup>
                        {isValid === false && lastFocus===true && (
                        <div className=''>
                            <p style={{color:'red', fontSize:'10px'}}>Enter valid email...</p>
                        </div>
                        )}
                        <div className="textarea-container">
                            <Input
                                cols="80"
                                name="msg"
                                placeholder="Type a message..."
                                rows="4"
                                type="textarea"
                                value={data.msg}
                                onChange={(e)=>handleChange(e)}
                            ></Input>
                        </div>
                        <div className="send-button">
                            <Button
                                block
                                className="btn-round"
                                color="success"
                                href="#pablo"
                                onClick={()=>submit()}
                                size="lg"
                                style={{maxHeight:'55px'}}
                            >
                                {submitting === true && (
                                <>
                                <p className='mb-5'><b>Sending Message</b></p>
                                </>
                                )
                                }
                                {submitting === false && (
                                    <p className='mb-1'><b>Send Message</b></p>
                                )}
                            </Button>
                        </div>
                    </Col>
                </Row>
                {resStatus===200 && modal2 &&(
                    <Modal
                        modalClassName="modal-mini modal-success"
                        toggle={() => setModal2(false)}
                        isOpen={modal2}
                    >
                        <ModalBody>
                            <p>Message Submitted Successfully!</p>
                            <small>We will get back to you shortly. Thank you.</small>
                        </ModalBody>
                            <div className="modal-footer">
                                <Button
                                    className="btn-neutral"
                                    color="neutral"
                                    type="button"
                                    onClick={() => setModal2(false)}
                                >
                                    Close
                                </Button>
                            </div>
                    </Modal>
                )}
                {resStatus!==200 && modal1 && (
                    <Modal
                    modalClassName="modal-mini modal-warning"
                    toggle={() => setModal1(false)}
                    isOpen={modal1}
                    >
                        <ModalBody>
                            <p>Message Submission Failed!</p>
                            <small>Please Re-Input your details correctly. Thank you.</small>
                        </ModalBody>
                        <div className="modal-footer">
                            <Button
                                className="btn-neutral"
                                color="neutral"
                                type="button"
                                onClick={() => setModal1(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </Modal>
                )}
            </Container>
            
        </div>
        </>
        
    )
}
